// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"110":"845f6a87","163":"845f6a87","870":"33411923"}[chunkId] + ".chunk.css";
};